import React from 'react';
import { View, TouchableOpacity } from 'react-native';
import TipsStyle from './style';
import { Icon } from '@qnpm/q-theme';
import { qAccessibilityLabel } from '@qnpm/q-design-utils';
const ICON_STYLE = new TipsStyle(false);
export class LeftIcon extends React.PureComponent {
    getIconContent(icon, brandColor, styles, needScale) {
        if (React.isValidElement(icon)) {
            return icon;
        }
        if (typeof icon === 'string') {
            return (<View style={styles.leftIcon}>
                    <Icon name={icon} size={18} needScale={needScale} color={brandColor}/>
                </View>);
        }
        return null;
    }
    render() {
        let needScale = this.props.needScale;
        ICON_STYLE.setIsScale(this.props.needScale);
        let styles = ICON_STYLE.getStyle();
        const { icon, brandColor } = this.props;
        const main = this.getIconContent(icon, brandColor, styles, needScale);
        return main ? <View style={styles.left12}>{main}</View> : null;
    }
}
export const mode2Icon = {
    closable: 'close',
    link: 'chevronForward'
};
export class RightIcon extends React.PureComponent {
    // eslint-disable-next-line max-params
    getIconContent(mode, icon, brandColor, needScale, rightIconType, onClose, accessibilityPreName) {
        if (rightIconType === 'merge' && React.isValidElement(icon)) {
            return (<>
                    {icon}
                    <TouchableOpacity hitSlop={{ left: 8, right: 8, top: 8, bottom: 8 }} onPress={onClose} accessible={false} {...qAccessibilityLabel(`${accessibilityPreName}qdTip#close`)}>
                        <Icon needScale={needScale} name={mode2Icon[mode]} size={12} style={{ marginTop: 2 }} color={brandColor}/>
                    </TouchableOpacity>
                </>);
        }
        if (React.isValidElement(icon)) {
            return icon;
        }
        if (mode === 'closable') {
            return (<TouchableOpacity hitSlop={{ left: 10, right: 10, top: 10, bottom: 10 }} onPress={onClose} accessible={false} {...qAccessibilityLabel(`${accessibilityPreName}qdTip#close`)}>
                    <Icon needScale={needScale} name={mode2Icon[mode]} size={12} color={brandColor}/>
                </TouchableOpacity>);
        }
        if (mode === 'link') {
            return (<Icon needScale={needScale} name={mode2Icon[mode]} size={12} color={brandColor}/>);
        }
        return null;
    }
    render() {
        ICON_STYLE.setIsScale(this.props.needScale);
        let styles = ICON_STYLE.getStyle();
        const { mode, icon, brandColor, needScale, rightIconType, onClose, accessibilityPreName } = this.props;
        const main = this.getIconContent(mode, icon, brandColor, needScale, rightIconType, onClose, accessibilityPreName);
        return main ? <View style={styles.actionWrap}>{main}</View> : null;
    }
}
